/* BildLokal – Shopify-Verbindung
   ============================================================
   Diese Datei verbindet den Webshop mit dem echten Shopify-Store
   (bildlokal.ch). Trage hier deinen Storefront-API-Token ein.

   So bekommst du den Token (einmalig, ca. 2 Minuten):
   1. Shopify-Admin öffnen → Einstellungen → Apps und Vertriebskanäle
   2. "Headless" hinzufügen (Shopify-eigener Kanal für genau diesen
      Zweck: eigenes Frontend + Shopify-Checkout) – im App Store danach suchen.
      Alternativ: "Develop apps" → "App erstellen" → unter
      "Configuration" die Storefront-API aktivieren und Zugriff auf
      Produkte, Inventar und Carts/Checkouts erlauben → App installieren.
   3. Im Reiter "API credentials" bzw. im Headless-Kanal unter
      "Storefronts" den "Storefront API access token" kopieren.
   4. Token unten bei STOREFRONT_ACCESS_TOKEN einfügen und speichern.

   Der Storefront-Token ist ein ÖFFENTLICHER Token (kein Geheimnis wie
   ein Admin-API-Token) – er ist extra dafür gemacht, im Frontend-Code
   zu stehen. Er kann nur lesen und Carts/Checkouts erstellen, niemals
   Bestellungen, Kundendaten oder Einstellungen ändern.
   ============================================================ */

const SHOPIFY_CONFIG = {
  // *.myshopify.com-Domain – die Storefront API läuft immer darüber,
  // auch wenn im Shop die eigene Domain bildlokal.ch verwendet wird.
  domain: "ikcema-11.myshopify.com",

  // TODO: Hier deinen Storefront-API-Token einfügen (siehe Anleitung oben).
  storefrontAccessToken: "c88b5853d727042cbeec11a31d9c7952",

  apiVersion: "2025-01",
};
